import { useEffect, useState } from "react";
import {
  Box,
  Table,
  Paper,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Pagination,
  PaginationItem,
  Button,
} from "@mui/material";

import LessonStatusToggle from "../components/Lesson/LessonStatusToggle";
import {
  createLessonsAPIEndpoint,
  EndPoints,
} from "../../../services/LessonAPI";
import LessonDialog from "../components/Lesson/LessonDetailsDialog";
import AddLessonDialog from "../components/Lesson/AddLessonDialog";
import { CenterEndPoints, createGeneralAPIEndpoint } from "../../../services/General";

function Lessons() {
  const [lessons, setLessons] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const [search, setSearch] = useState("");
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedLesson, setSelectedLesson] = useState(null);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [centers, setCenters] = useState([]);

  const fetchLessons = (page, pageSize, search) => {
    createLessonsAPIEndpoint(EndPoints.searchLessons)
      .fetch({ params: { search, page: page + 1, pageSize } })
      .then((response) => {
        setLessons(response.data.items || []);
        setTotalCount(response.data.totalCount || 0);
      })
      .catch((error) => {
        console.error("Error fetching lesson data:", error);
        setLessons([]);
      });
  };

  const handleViewClick = (lesson) => {
    setSelectedLesson(lesson);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    fetchLessons(page, pageSize, search);
    setOpenDialog(false);
  };
  const handleLessonSaved = () => {
    fetchLessons(page, pageSize, search);
    handleCloseDialog();
  };

  const handleLessonAdded = (newLesson) => {
    setLessons((prevLessons) => [...prevLessons, newLesson]);
    setOpenAddDialog(false);
    fetchLessons(page, pageSize, search);
  };
  useEffect(() => {
    createGeneralAPIEndpoint(CenterEndPoints.all)
      .fetch()
      .then((res) => {
        setCenters(res.data || []);
      })
      .catch((err) => {
        console.error("Failed to fetch centers data:", err);
      });
    fetchLessons(page, pageSize, search);
  }, [page, pageSize, search, openDialog]);

  return (
    <section className="dashboard-section">
      <div className="table-wrapper">
        <TableContainer
          component={Paper}
          sx={{ margin: "2rem auto" }}
          className="table-container"
        >
          <Box className="table-box">
            <TextField
              label="Search"
              variant="standard"
              size="large"
              value={search}
              onChange={(e) => {
                setPage(0);
                setSearch(e.target.value);
              }}
              className="search-field"
            />
            <Button
              variant="outlined"
              className="btn-add-record"
              onClick={() => setOpenAddDialog(true)}
            >
              Add New Lesson
            </Button>
          </Box>
          <div className="table-title">Lessons Data</div>
          <Table className="table">
            <TableHead>
              <TableRow>
                <TableCell className="table-header">
                  <b>Title</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Center</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Max Views</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Codes Generated</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Codes Used</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Status</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Is Free</b>
                </TableCell>
                <TableCell className="table-header">
                  <b>Actions</b>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.isArray(lessons) && lessons.length !== 0 ? (
                lessons.map((lesson) => (
                  <TableRow key={lesson.id} className="table-row">
                    <TableCell className="table-cell">
                      {lesson.title || "N/A"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {lesson.centerName || "N/A"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {lesson.maxViewPerStudent}
                    </TableCell>
                    <TableCell className="table-cell">
                      {lesson.numOfCodesGenerated}
                    </TableCell>
                    <TableCell className="table-cell">
                      {lesson.numOfCodesUsed}
                    </TableCell>
                    <TableCell className={`table-cell status-cell ${lesson.isActive ? 'active' : 'inactive'}`}>
                      {lesson.isActive ? "Active" : "Inactive"}
                    </TableCell>
                    <TableCell className="table-cell">
                      {lesson.isFree ? "Yes" : "No"}
                    </TableCell>
                    <TableCell className="table-cell action-cell">
                      <Button
                        className="btn-view"
                        onClick={() => handleViewClick(lesson)}
                      >
                        View
                      </Button>
                      <LessonStatusToggle
                        lesson={lesson}
                        fetchLessons={fetchLessons}
                        page={page}
                        pageSize={pageSize}
                        search={search}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className="table-cell">
                    No lessons found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <Pagination
            className="pagination"
            page={page + 1}
            count={Math.ceil(totalCount / pageSize)}
            onChange={(event, newPage) => setPage(newPage - 1)}
            renderItem={(item) => <PaginationItem component="div" {...item} />}
          />
          <LessonDialog
            openDialog={openDialog}
            handleCloseDialog={handleCloseDialog}
            selectedLesson={selectedLesson}
            onSave={handleLessonSaved}
            centers={centers}
          />
          <AddLessonDialog
            open={openAddDialog}
            onClose={() => setOpenAddDialog(false)}
            onLessonAdded={handleLessonAdded}
            centers={centers}
          />
        </TableContainer>
      </div>
    </section>
  );
}
export default Lessons;
